<template>
  <div v-if="loadHAppComponent">
    <v-card class="mx-auto" width="256" tile>
      <v-navigation-drawer permanent>
        <div class="text-center" style="padding-top: 20px;">
          <v-chip class="ma-2" color="lime darken-2" text-color="white">
            <v-avatar left>
              <v-icon small>mdi-office-building-marker-outline</v-icon>
            </v-avatar>
            <strong>hApp</strong> Properties
          </v-chip>
        </div>
        <v-divider></v-divider>
        <v-container>
          <v-tooltip top color="#827717">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-text-field
                  background-color="lime lighten-5"
                  dense
                  label="Name"
                  placeholder="Name..."
                  filled
                  disabled
                  v-model="hApp.name"
                ></v-text-field>
              </div>
            </template>
            <span v-text="hApp.name"></span>
          </v-tooltip>

          <v-expansion-panels dark multiple>
            <v-expansion-panel style="background: rgba(0,0,0,0.2);">
              <v-expansion-panel-header>Position</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-text-field
                  dark
                  dense
                  label="X"
                  placeholder="x"
                  outlined
                  type="number"
                  v-model="hApp.content.position.x"
                ></v-text-field>
                <v-text-field
                  dark
                  dense
                  label="Y"
                  placeholder="y"
                  outlined
                  type="number"
                  v-model="hApp.content.position.y"
                ></v-text-field>
                <v-text-field
                  dark
                  dense
                  label="Z"
                  placeholder="z"
                  outlined
                  type="number"
                  v-model="hApp.content.position.z"
                ></v-text-field>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </v-navigation-drawer>
    </v-card>
    <br />
    <!-- <HObjectPropertiesComponent
      v-for="(hObject, iHObject) in hApp.content.hObjects"
      :key="iHObject"
      :hObject="hObject"
    />-->
  </div>
</template>

<script>
import HObjectPropertiesComponent from '@/components/HObject/Properties'

import { mapState } from 'vuex'
import { EventBus } from '@/js/EventBus.js'

export default {
  name: 'hAppPropertiesComponent',
  components: {
    HObjectPropertiesComponent
  },
  data () {
    return {
      loadHAppComponent: false,
      hApp: {}
    }
  },
  mounted: function () {
    this.getDataUser()
    this.loadEventBusOn()
  },
  methods: {
    getDataUser () {
      this.usuario = JSON.parse(
        sessionStorage.getItem('datos_usuario_autenticado')
      )
    },
    loadEventBusOn () {
      EventBus.$on('LoadHAppComponent', hApp => {
        this.hApp = hApp
        this.loadHAppComponent = true
      })
    }
  }
}
</script>

<style scoped>
.v-card {
  background-color: rgba(0, 0, 0, 0.4);
  color: white;
  border: 1px solid #626f76;
  margin-bottom: 0.2rem;
}

.v-navigation-drawer {
  background-color: rgba(0, 0, 0, 0) !important;
}

.v-icon {
  color: #f9fbe7;
}

.v-list-item__title {
  color: #f9fbe7;
}

.v-list-item:hover {
  background-color: #9e9d24;
}

.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HApp/Properties.vue